var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0",attrs:{"data-qa":"accountview-container-q3o0r"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }